// extracted by mini-css-extract-plugin
export default {"ConfirmationModal":"OnePager_ConfirmationModal__QVZ8-","Title":"OnePager_Title__9JXnE","Subtext":"OnePager_Subtext__AvbOZ","Buttons":"OnePager_Buttons__MsOlU"};